export const member = {
  list: '会员列表',
  from: '会员操作',
  info: '会员信息',
  view: '会员详情',
  delete: '删除会员',

  avatar: '会员头像',
  username: '登录账户',
  nickname: '会员昵称',
  mobile: '手机号码',
  email: '电子邮箱',
  status: '账号状态',
  role_title: '会员身份',
  organization_info: '机构信息',
  last_login_time: '最后登录时间',
  create_time: '注册时间',

  rules: {
    username: {
      require: '登录账户不能为空',
    },
    nickname: {
      require: '会员昵称不能为空',
    },
  },

  behavior: {
    list: '行为列表',
    base_info: '数据统计',

    project_total: '项目浏览',
    demand_total: '需求浏览',
    article_total: '资讯浏览',
    update_time: '最新操作时间',
    than_yesterday: '比昨天新增',

    project: {
      info: '项目浏览行为',

      title: '项目标题',
      create_time: '操作时间',
    },

    demand: {
      info: '需求浏览行为',

      title: '需求标题',
      create_time: '操作时间',
    },

    article: {
      info: '资讯浏览行为',

      title: '资讯标题',
      create_time: '操作时间',
    },
  },

  balance: {
    info: '资产信息',

    money: '资产金额',
    add_money: '添加金额',

    income: {
      info: '会员收入',

      type: '收入来源',
      money: '收入金额',
      create_time: '收入时间',
    },

    expense: {
      info: '会员支出',

      type: '支出原因',
      money: '支出金额',
      create_time: '支出时间',
    },
  },

  credit: {
    score: '信用分数',
  },

  invite: {
    list: '邀请列表',
    info: '会员邀请',

    nickname: '会员信息',
    create_time: '邀请时间',
  },

  report: {
    list: '举报列表',
    form: '举报审核',
    info: '审核信息',

    member_info: '被举报人信息',
    article_info: '公众号文章信息',

    audit_status: '审核状态',
    content: '举报内容',
    create_time: '举报时间',

    rules: {
      audit_status: {
        require: '审核状态不能为空',
      },
    },
  },

  browse: {
    browse_total: '原文阅读量',
    url: '原文截图',
  }
}
